import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X, Fullscreen } from "lucide-react";

interface WalkthroughModalProps {
  isOpen: boolean;
  onClose: () => void;
  widgetUrl: string;
  modelName: string;
}

export const WalkthroughModal = ({ isOpen, onClose, widgetUrl, modelName }: WalkthroughModalProps) => {
  const openFullscreen = () => {
    window.open(widgetUrl, '_blank');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl max-h-[90vh] p-0" hideCloseButton>
        <DialogHeader className="bg-[#E4683B] px-6 py-4 flex flex-row items-center justify-between">
          <DialogTitle className="text-lg font-light text-black">
            {modelName} - 360° Walkthrough
          </DialogTitle>
          <div className="flex items-center gap-2">
            <Button
              onClick={openFullscreen}
              variant="ghost"
              size="sm"
              className="p-1 hover:bg-black/10 rounded text-black"
              title="Open in fullscreen"
            >
              <Fullscreen className="h-5 w-5" />
            </Button>
            <Button
              onClick={onClose}
              variant="ghost"
              size="sm"
              className="p-1 hover:bg-black/10 rounded text-black"
            >
              <X className="h-5 w-5" />
            </Button>
          </div>
        </DialogHeader>
        
        <div className="h-2 bg-[#E4683B]"></div>
        
        <div className="flex-1 min-h-0">
          <iframe
            src={widgetUrl}
            width="100%"
            height="600px"
            frameBorder="0"
            title={`${modelName} 360° Walkthrough`}
            className="w-full"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};